import { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNotification } from "../context/NotificationContext";
import { apiService } from "../services/api";
import octopusInstance from "../services/octopus/octopusInstance";
import { getExchangeCode } from "../services/exchanges";
import { fetchProfileDataAction } from "../store/actions/profile";
import { fetchPositionsAction } from "../store/actions/portfolio";
// import { getMarginType } from "../utils/utilfunction";
import { extractSymbolForMargin, isValidMultiple } from "./useOrderFormUtils";
import { calcMinimumQuantity, getMinimumOrderValue } from "./useOrderFormCore";
import { closeOrderWindow } from '../store/actions/orders';
// import { fetchFundsViewV2 } from "../services/backendAPI";
// import { fetchFundsView } from "../store/actions/funds";
import { enqueueSnackbar } from "notistack";
import { addBasketInstrumentAction, updateBasketInstrumentAction } from "../store/actions/basket";
import { createBasketOrderPayload } from "../utils/basketUtils";
// SIMPLIFIED: Only match Symbol + Product Type + Time Range
// core helpers split out for readability
export { getMarginMultiplierFromConfig, calcMargin, calcMinimumQuantity, getMinimumOrderValue } from "./useOrderFormCore";



// export const PRIME_SETTINGS = {

//   "NSE": {
//     "intraday": {
//       "multiplier": 500,
//       "absolute": 0
//     },
//     "overnight": {
//       "multiplier": 500,
//       "absolute": 0
//     },
//     "OPTIONS": {
//       "BUY": {
//         "intraday": {
//           "multiplier": 10,
//           "minimumValue": 4500,
//           "absolute": 0
//         },
//         "overnight": {
//           "multiplier": 2,
//           "minimumValue": 900,
//           "absolute": 0
//         }
//       },
//       "SELL": {
//         "intraday": {
//           "multiplier": 0,
//           "minimumValue": 0,
//           "absolute": 20000
//         },
//         "overnight": {
//           "multiplier": 0,
//           "minimumValue": 0,
//           "absolute": 20000
//         }
//       }
//     }
//   },
//   "NFO": {
//     "FUTURES": {
//       "BUY": {
//         "intraday": {
//           "multiplier": 500,
//           "minimumValue": 225000,
//           "absolute": 0
//         },
//         "overnight": {
//           "multiplier": 50,
//           "minimumValue": 22500,
//           "absolute": 0
//         }
//       },
//       "SELL": {
//         "intraday": {
//           "multiplier": 500,
//           "minimumValue": 225000,
//           "absolute": 0
//         },
//         "overnight": {
//           "multiplier": 50,
//           "minimumValue": 22500,
//           "absolute": 0
//         }
//       }
//     },
//     "OPTIONS": {
//       "BUY": {
//         "intraday": {
//           "multiplier": 10,
//           "minimumValue": 4500,
//           "absolute": 0
//         },
//         "overnight": {
//           "multiplier": 2,
//           "minimumValue": 900,
//           "absolute": 0
//         }
//       },
//       "SELL": {
//         "intraday": {
//           "multiplier": 0,
//           "minimumValue": 225000,
//           "absolute": 20000
//         },
//         "overnight": {
//           "multiplier": 0,
//           "minimumValue": 50000,
//           "absolute": 20000
//         }
//       }
//     }
//   },
//   "MCX": {
//     "FUTURES": {
//       "BUY": {
//         "intraday": {
//           "multiplier": 500,
//           "minimumValue": 225000,
//           "absolute": 0
//         },
//         "overnight": {
//           "multiplier": 100,
//           "minimumValue": 45000,
//           "absolute": 0
//         }
//       },
//       "SELL": {
//         "intraday": {
//           "multiplier": 500,
//           "minimumValue": 225000,
//           "absolute": 0
//         },
//         "overnight": {
//           "multiplier": 100,
//           "minimumValue": 45000,
//           "absolute": 0
//         }
//       }
//     },
//     "OPTIONS": {
//       "BUY": {
//         "intraday": {
//           "multiplier": 10,
//           "minimumValue": 4500,
//           "absolute": 0
//         },
//         "overnight": {
//           "multiplier": 2,
//           "minimumValue":900,
//           "absolute": 0
//         }
//       },
//       "SELL": {
//         "intraday": {
//           "multiplier": 0,
//           "minimumValue": 225000,
//           "absolute": 20000
//         },
//         "overnight": {
//           "multiplier": 0,
//           "minimumValue": 50000,
//           "absolute": 20000
//         }
//       }
//     }
//   },
//   "CDS": {
//     "FUTURES": {
//       "BUY": {
//         "intraday": {
//           "multiplier": 100,
//           "minimumValue": 45000,
//           "absolute": 0
//         },
//         "overnight": {
//           "multiplier": 100,
//           "minimumValue": 45000,
//           "absolute": 0
//         }
//       },
//       "SELL": {
//         "intraday": {
//           "multiplier": 100,
//           "minimumValue": 45000,
//           "absolute": 0
//         },
//         "overnight": {
//           "multiplier": 100,
//           "minimumValue": 45000,
//           "absolute": 0
//         }
//       }
//     },
//     "OPTIONS": {
//       "BUY": {
//         "intraday": {
//           "multiplier": 100,
//           "minimumValue": 45000,
//           "absolute": 0
//         },
//         "overnight": {
//           "multiplier": 100,
//           "minimumValue": 45000,
//           "absolute": 0
//         }
//       },
//       "SELL": {
//         "intraday": {
//           "multiplier": 100,
//           "minimumValue": 45000,
//           // "absolute": 20000
//         },
//         "overnight": {
//           "multiplier": 100,
//           "minimumValue": 45000,
//           // "absolute": 20000
//         }
//       }
//     }
//   },

// }







// Function to get the minimum order value for display

export const useOrderForm = ({
  type,
  ltp,
  exchange,
  token,
  channel,
  lotsize,
  tick_size,
  execution,
  bestBid,
  bestAsk,
  payload,
  alternate_exchange,
  onClose,
  trading_symbol,
  onTypeChange,
  is_modify,
  is_repeat,
  oms_order_id,
  exchange_order_id,
  open,
  strike_price
}) => {
  const dispatch = useDispatch();
  const { userData, isLoaded } = useSelector((state) => state.profile);
  useEffect(() => {
    if (!isLoaded) {
      dispatch(fetchProfileDataAction());
    }
  }, [dispatch, isLoaded]);
  // const { userSettings } = useSelector((state) => state.profile);
  const userSettings = useSelector((state) => {
    const settings = state.profile.userSettings;
    return settings;
  });
  const PRIME_SETTINGS = userSettings.order_margin;
  // Get margin configuration from Redux (read-only)
  const marginConfig = useSelector((state) => state.margin.marginConfig);
  const marginConfigLoading = useSelector((state) => state.margin.loading);
  const marginConfigError = useSelector((state) => state.margin.error);
  const positionData = useSelector((state) => state.portfolio.arrPositionsUpdateData);

  const [orderType, setOrderType] = useState(payload?.order_type);
  const [quantity, setQuantity] = useState("1");
  const [price, setPrice] = useState(payload?.price || ltp || 0);
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  const [hideMargin, setHideMargin] = useState(false);
  const [currentLTP, setCurrentLTP] = useState(ltp);
  const [initialLTP, setInitialLTP] = useState(ltp);
  const [originalPrice, setOriginalPrice] = useState(null);
  const [originalTriggerPrice, setOriginalTriggerPrice] = useState(null);
  // Removed unused: originalOrderType, originalProduct
  const [currentBestBid, setCurrentBestBid] = useState(bestBid);
  const [currentBestAsk, setCurrentBestAsk] = useState(bestAsk);
  const [product, setProduct] = useState("");
  const [validity, setValidity] = useState("DAY");
  const [executionType, setExecutionType] = useState("REGULAR");
  // Removed unused: lowDpr, highDpr
  const [priceError, setPriceError] = useState(false);
  const [triggerError, setTriggerError] = useState(false);
  const [quantityError, setQuantityError] = useState(false);
  const [orderSide, setOrderSide] = useState(type);
  const [orderDetails, setOrderDetails] = useState({
    trigger_price: ltp,
    disclosed_qty: 0,
  });
  // Derived isDisabled is returned inline below based on square-off

  // Add state for minimum quantity required and minimum order value
  const [minimumQtyRequired, setMinimumQtyRequired] = useState(0);
  const [minimumOrderValue, setMinimumOrderValue] = useState(0);

  // Add a state variable to track if the order is a square-off order
  const [isSquareOffOrder, setIsSquareOffOrder] = useState(false);
  const [existingPositionQty, setExistingPositionQty] = useState(0);

  // Helper function to format price with precision for CDS exchange
  const formatPriceForCDS = useCallback((value) => {
    if (!value || value === 0) return value;

    // Get price precision from payload
    const pricePrecision = payload?.price_precision;

    if (exchange === 'CDS' && pricePrecision !== undefined) {
      // Apply precision and return as number
      return parseFloat(parseFloat(value).toFixed(pricePrecision));
    }

    return value;
  }, [exchange, payload?.price_precision]);

  // Calculate minimum quantity when relevant inputs change
  useEffect(() => {
    if (product && orderSide && exchange && payload?.instrument_name) {
      // Extract symbol for margin config matching
      const extractedSymbol = extractSymbolForMargin(exchange, trading_symbol, payload);
      const defaultNseEquity =
        PRIME_SETTINGS?.NSE?.EQUITY?.BUY?.intraday ||
        PRIME_SETTINGS?.NSE?.EQUITY?.SELL?.intraday;

      console.log("🔍 useOrderForm Symbol extraction:", {
        exchange,
        trading_symbol,
        payload_trading_symbol: payload?.trading_symbol,
        payload_display_name: payload?.display_name,
        extractedSymbol
      });

      // For market orders, use the best bid/ask price instead of the order price
      let priceToUse = parseFloat(price || 0);

      if (orderType === "MARKET" || orderType === "STOPLOSSMARKET") {
        priceToUse = orderSide === "BUY" ?
          parseFloat(currentBestAsk || 0) :
          parseFloat(currentBestBid || 0);
      }

      if (priceToUse <= 0 && currentLTP) {
        // Fallback to LTP if best bid/ask not available
        priceToUse = parseFloat(currentLTP);
      }

      // Reset square-off state
      setIsSquareOffOrder(false);
      setExistingPositionQty(0);

      // Get the isSquareOff flag from payload
      const isDirectSquareOff = payload?.isSquareOff || false;

      // Only calculate if we have a valid price
      if (priceToUse > 0) {
        // Log all relevant variables for option sell orders
        if (orderSide === "SELL" && payload?.instrument_name?.startsWith("OPT")) {
          console.log("OPTION SELL ORDER DETECTED - Input variables:", {
            exchange,
            priceToUse,
            isDirectSquareOff,
            raw_board_lot_quantity: payload?.raw_board_lot_quantity,
            instrumentName: payload?.instrument_name,
            orderSide,
            product
          });

          // Special logging for MCX exchange
          if (exchange === "MCX") {
            // Reserved for potential future debug of MCX config
          }
        }

        // Calculate base minimum quantity, passing the square-off flag and dynamic margin config
        const baseMinQty = calcMinimumQuantity({
          order_config: PRIME_SETTINGS,
          exchange,
          orderSide,
          product,
          price: priceToUse,
          instrumentName: payload?.instrument_name,
          isSquareOff: isDirectSquareOff, // Pass the square-off flag
          raw_board_lot_quantity: payload?.raw_board_lot_quantity || 1,
          marginConfig: marginConfig, // Pass dynamic margin config
          symbol: extractedSymbol, // Pass extracted symbol
          instrumentDetails: payload, // Pass instrument details
          defaultEquityConfig: defaultNseEquity,
        });

        // Check for matching positions to potentially adjust minimum quantity
        let effectiveMinQty = baseMinQty;
        const positionsArray = positionData || [];

        if (positionsArray && positionsArray.length > 0 && !isDirectSquareOff) {
          // Skip position check if it's a direct square-off
          // Find matching position with same token and product type
          const matchingPosition = positionsArray.find(position =>
            (String(position.token) === String(payload?.token) ||
              String(position.instrument_token) === String(payload?.token)) &&
            position.net_quantity !== 0 &&
            position.product === product
          );

          if (matchingPosition) {
            const netQuantity = Number(matchingPosition.net_quantity) || 0;
            const positionSide = netQuantity < 0 ? "SELL" : netQuantity > 0 ? "BUY" : null;
            const existingQty = Math.abs(netQuantity);

            // Set existing position quantity for validation purposes
            setExistingPositionQty(existingQty);

            if (positionSide) {
              // If positions are in the same direction, we already have some quantity
              // For example: if we have a BUY position and placing another BUY order
              if (positionSide === orderSide) {
                // Reduce minimum required quantity by existing position quantity
                effectiveMinQty = Math.max(0, baseMinQty - existingQty);
              }
              // If positions are in opposite direction, it's a square-off
              else if (positionSide !== orderSide) {
                // For square-off positions, we'll bypass minimum quantity validation
                // when the entered quantity is less than or equal to existing position
                setIsSquareOffOrder(true);

                // Set effective min qty to zero for square-offs
                effectiveMinQty = 0;
              }
            }
          }
        }

        // If it's a direct square-off, minimum quantity should be 0
        setMinimumQtyRequired(isDirectSquareOff ? 0 : effectiveMinQty);

        // Calculate minimum order value for display
        const minOrderValue = isDirectSquareOff ? 0 : getMinimumOrderValue({
          order_config: PRIME_SETTINGS,
          exchange,
          orderSide,
          product,
          instrumentName: payload?.instrument_name,
          raw_board_lot_quantity: payload?.raw_board_lot_quantity || 1,
          marginConfig: marginConfig, // Pass dynamic margin config
          symbol: extractedSymbol, // Pass extracted symbol
          instrumentDetails: payload, // Pass instrument details
          defaultEquityConfig: defaultNseEquity,
        });

        setMinimumOrderValue(minOrderValue);
      }
    }
  }, [product, price, orderType, orderSide, exchange, payload, payload?.instrument_name, payload?.token, currentBestAsk, currentBestBid, currentLTP, payload?.raw_board_lot_quantity, PRIME_SETTINGS, marginConfig, trading_symbol]);

  // Update the quantity error handling to bypass validation for ALL square-off operations
  useEffect(() => {
    const numericQty = parseInt(quantity) || 0;
    const isDirectSquareOff = payload?.isSquareOff || false;

    // FIRST CHECK: Direct square-off from payload flag
    if (isDirectSquareOff) {
      console.log("Direct square-off detected - bypassing quantity validation");
      setQuantityError(false);
      return;
    }

    // SECOND CHECK: Square-off detected from position matching 
    if (isSquareOffOrder && numericQty <= existingPositionQty) {
      console.log("Position-based square-off detected - bypassing quantity validation for", numericQty, "vs", existingPositionQty);
      setQuantityError(false);
      return;
    }

    // THIRD CHECK: Square-off with quantity below or equal to existing position
    // Check if there's a matching position with opposite direction 
    const positionsArray = positionData || [];
    if (positionsArray && positionsArray.length > 0) {
      const matchingPosition = positionsArray.find(position =>
        (String(position.token) === String(payload?.token) ||
          String(position.instrument_token) === String(payload?.token)) &&
        position.net_quantity !== 0 &&
        position.product === product
      );

      if (matchingPosition) {
        const netQuantity = Number(matchingPosition.net_quantity) || 0;
        const positionSide = netQuantity < 0 ? "SELL" : "BUY";

        // If this is a square-off order (opposite direction of position)
        if ((positionSide === "BUY" && orderSide === "SELL") ||
          (positionSide === "SELL" && orderSide === "BUY")) {

          // If entered quantity is less than or equal to position quantity, it's a valid square-off
          if (numericQty <= Math.abs(netQuantity)) {
            console.log("Valid square-off quantity detected:", numericQty, "vs position", Math.abs(netQuantity));
            setQuantityError(false);
            return;
          }
        }
      }
    }

    // If not a square-off operation, apply normal validation
    setQuantityError(numericQty <= 0);
  }, [quantity, payload?.token, orderSide, product, isSquareOffOrder, existingPositionQty, payload?.isSquareOff]);

  useEffect(() => {
    if (open) {

      // Check for square-off operation
      const isSquareOffOperation = payload?.isSquareOff || false;
      if (isSquareOffOperation) {
        console.log("Square-off operation detected during initialization");
        // For square-off operations, ensure quantityError is false
        setQuantityError(false);
        setMinimumQtyRequired(0);
      }

      setInitialLTP(ltp);
      setProduct(payload.product);
      setOrderType(payload?.order_type || "LIMIT");
      const defaultQtyByExchange = userSettings?.default_qty_by_exchange?.[payload.exchange];
      const defaultQty = defaultQtyByExchange ? String(defaultQtyByExchange) : "1";
      setQuantity(
        !payload.diplayNetQuantity ? defaultQty : payload?.lot_size || payload?.lotsize
      );
      setHideMargin(payload.diplayNetQuantity);

      // Don't set quantityError for square-off operations
      if (!isSquareOffOperation) {
        setQuantityError(false);
      }

      if (is_modify || is_repeat) {
        // Rest of the modify/repeat code remains unchanged
        const modifyPrice = payload?.ltp || 0;
        setOriginalPrice(modifyPrice);
        setOriginalTriggerPrice(payload?.trigger_price || 0);
        // original order type/product were unused
        setProduct(payload?.product);
        setPrice(orderType === "STOPLOSSMARKET" ? 0 : formatPriceForCDS(payload.price));
        setQuantity(payload?.quantity);

        const triggerPrice =
          orderType === "STOPLOSSMARKET" || orderType === "SL"
            ? payload?.trigger_price || modifyPrice || 0
            : 0;

        setOrderDetails((prev) => ({
          ...prev,
          trigger_price: triggerPrice,
          disclosed_qty: payload?.disclosed_qty || payload?.disclosed_quantity || 0,
        }));
      } else {
        setOriginalPrice(null);
        setOriginalTriggerPrice(null);
        // original order type/product were unused
        setPrice(orderType === "STOPLOSSMARKET" ? 0 : formatPriceForCDS(ltp));
        setCurrentLTP(ltp);

        setOrderDetails((prev) => ({
          ...prev,
          trigger_price: 0,
          disclosed_qty: 0,
        }));
      }
    }
    // Note: intentionally excluding orderType to avoid resetting product when switching order type
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, payload, is_modify, is_repeat, ltp, exchange, formatPriceForCDS]);

  useEffect(() => {
    if (orderType === "MARKET") {
      setPrice(0);
      setOrderDetails((prev) => ({ ...prev, trigger_price: 0 }));
    } else if (orderType === "STOPLOSSMARKET") {
      setPrice(0);
      if (is_modify || is_repeat) {
        const preservedTriggerPrice =
          payload?.trigger_price ||
          originalTriggerPrice ||
          (payload?.price && parseFloat(payload.price) > 0
            ? payload.price
            : initialLTP);

        setOrderDetails((prev) => ({
          ...prev,
          trigger_price: preservedTriggerPrice,
        }));
      } else {
        setOrderDetails((prev) => ({
          ...prev,
          trigger_price: initialLTP,
        }));
      }
    } else if (orderType === "SL") {
      const preservedPrice = payload?.price || initialLTP;
      const preservedTriggerPrice =
        payload?.trigger_price ||
        originalTriggerPrice ||
        preservedPrice ||
        initialLTP;

      setPrice(formatPriceForCDS(preservedPrice));
      setOrderDetails((prev) => ({
        ...prev,
        trigger_price: preservedTriggerPrice,
      }));
    } else if (orderType === "LIMIT") {
      setPrice(formatPriceForCDS(payload?.price || initialLTP));
      setOrderDetails((prev) => ({
        ...prev,
        trigger_price: 0,
      }));
    }
  }, [
    orderType,
    initialLTP,
    is_modify,
    is_repeat,
    payload,
    originalPrice,
    originalTriggerPrice,
    formatPriceForCDS,
  ]);

  useEffect(() => {
    if (!open || !exchange || !token) return;
    const subscriptionLocation = `buy-sell-modal`;
    const handler = octopusInstance.wsHandler({
      messageType:
        execution === "SPREAD"
          ? "SpreadMarketUpdate"
          : "CompactMarketDataMessage",
      subscriptionLocation,
      payload: {
        exchangeCode: getExchangeCode(exchange),
        instrumentToken: token ? token : null,
      },
    });

    handler.subscribe(({ msg }) => {
      setCurrentBestBid(msg.bidPrice);
      setCurrentBestAsk(msg.askPrice);
      // removed: low/high dpr state (unused)
    });

    return handler.unsubscribe;
  }, [exchange, token, open, execution]);

  useEffect(() => {
    setOrderSide(type);
  }, [type]);

  const getProductOptions = () => {
    if (exchange === "NFO" || exchange === "BFO" || exchange === "MCX" || exchange === "CDS") {
      return ["MIS", "NRML"];
    } else if ((exchange === "NSE" || exchange === "BSE") && payload?.series?.toLowerCase() !== "indices") {
      return ["MIS", "CNC"];
    } else if ((exchange === "NSE" || exchange === "BSE") && payload?.series?.toLowerCase() === "indices") {
      return ["MIS", "NRML"];
    }else if (exchange === "DCSX") {
      return ["CNC"];
    }

    return ["MIS", "NRML"];
  };


  const hasMatchingPosition = (positionsArray, searchToken, orderSide, quantity, product) => {
    if (!positionsArray?.length || !searchToken || !orderSide) {
      return {
        hideMargin: false,
        netQuantity: Math.abs(quantity)
      }
    }

    const matchingPosition = positionsArray.find(position =>
      (String(position.token) === String(searchToken) ||
        String(position.instrument_token) === String(searchToken)) &&
      position.net_quantity !== 0 && position.product === product
    );

    if (!matchingPosition) {
      return {
        hideMargin: false,
        netQuantity: Math.abs(quantity)
      }
    }

    const netQuantity = Number(matchingPosition.net_quantity) || 0;
    const positionSide = netQuantity < 0 ? "SELL" : netQuantity > 0 ? "BUY" : "No Position";// For SELL order, we need positive quantity

    if (orderSide === "SELL" && positionSide === "BUY") {
      if (Number(quantity) <= Math.abs(netQuantity)) {
        return {
          hideMargin: true,
          netQuantity: 0
        };
      }
      else {
        return {
          hideMargin: false,
          netQuantity: Math.abs(quantity) - Math.abs(netQuantity)
        }
      }
    }
    if (orderSide === "SELL" && positionSide === "SELL") {

      return {
        hideMargin: false,
        netQuantity: quantity
      }
    }
    // For BUY order, we need negative quantity
    if (orderSide === "BUY" && positionSide === "SELL") {
      if (Number(quantity) <= Math.abs(netQuantity)) {
        return {
          hideMargin: true,
          netQuantity: 0
        };
      }
      else {
        return {
          hideMargin: false,
          netQuantity: Math.abs(quantity) - Math.abs(netQuantity)
        }
      }
    }
    if (orderSide === "BUY" && positionSide === "BUY") {
      return {
        hideMargin: false,
        netQuantity: quantity
      }
    }

  };


  const handleTypeChange = (event, newType) => {
    if (newType !== null && !is_modify && !payload?.isSquareOff) {
      setOrderSide(newType);
      if (onTypeChange) {
        onTypeChange(newType);
      }
    }
  };

  const handleChange = (field) => (e) => {
    setOrderDetails((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  // moved to utils: isValidMultiple

  const handlePriceChange = (e) => {
    const inputValue = parseFloat(e.target.value);
    const numericTickSize = parseFloat(tick_size);
    if (!isNaN(inputValue) && numericTickSize > 0) {
      const isValid = isValidMultiple(inputValue, numericTickSize);
      setPriceError(!isValid);
      setPrice(inputValue);
    } else {
      setPrice("");
      setPriceError(false);
    }
  };
  const handleTriggerChange = (e) => {
    const inputValue = parseFloat(e.target.value);
    const numericTickSize = parseFloat(tick_size);
    if (!isNaN(inputValue) && numericTickSize > 0) {
      const isValid = isValidMultiple(inputValue, numericTickSize);
      setTriggerError(!isValid);
      setOrderDetails((prev) => ({
        ...prev,
        trigger_price: inputValue,
      }));
    } else {
      setOrderDetails((prev) => ({
        ...prev,
        trigger_price: "",
      }));
      setTriggerError(false);
    }
  };

  const handleQuantityChange = (e) => {
    const inputValue = parseFloat(e.target.value);
    updateQuantity(inputValue);
  };

  const handleQuantityKeyDown = (e) => {
    const { exchange } = payload;
    let currentQty = parseFloat(quantity) || 0;

    if (e.key === "ArrowUp") {
      e.preventDefault();
      if (exchange === "MCX") {
        updateQuantity(currentQty + 1);
      } else {
        updateQuantity(currentQty + (lotsize || 1));
      }
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      let newQty;
      if (exchange === "MCX") {
        newQty = Math.max(0, currentQty - 1);
      } else {
        newQty = Math.max(0, currentQty - (lotsize || 1));
      }
      updateQuantity(newQty);
    }
  };

  const updateQuantity = (value) => {
    if (Number.isFinite(value)) {
      setQuantityError(value <= 0);
      setQuantity(value.toString());
    } else {
      setQuantity("");
      setQuantityError(true);
    }
  };

  const handlePriceKeyDown = (e) => {
    if (orderType === "MARKET") return;

    if (e.key === "ArrowUp") {
      e.preventDefault();
      const currentPrice = parseFloat(price) || 0;
      const newPrice = currentPrice + (tick_size || 0.05);
      setPrice(formatPriceForCDS(parseFloat(newPrice.toFixed(2))));
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      const currentPrice = parseFloat(price) || 0;
      const newPrice = currentPrice - (tick_size || 0.05);
      setPrice(formatPriceForCDS(parseFloat(newPrice.toFixed(2))));
    }
  };
  const handleTriggerKeyDown = (e) => {
    if (orderType === "MARKET") return;

    if (e.key === "ArrowUp") {
      e.preventDefault();
      const currentPrice = parseFloat(orderDetails.trigger_price) || 0; // Use trigger_price from orderDetails
      const updatedPrice = (currentPrice + (tick_size || 0.05)).toFixed(2);

      setOrderDetails((prevDetails) => ({
        ...prevDetails,
        trigger_price: updatedPrice, // Update trigger_price
      }));
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      const currentPrice = parseFloat(orderDetails.trigger_price) || 0; // Use trigger_price from orderDetails
      const updatedPrice = (currentPrice - (tick_size || 0.05)).toFixed(2);

      setOrderDetails((prevDetails) => ({
        ...prevDetails,
        trigger_price: updatedPrice, // Update trigger_price
      }));
    }
  };

  const computeIsReducingQty = (wasOpenedAsSquareOff) => {
    if (!wasOpenedAsSquareOff) return false;

    const numericQty = parseInt(quantity) || 0;
    if (!positionData || positionData.length === 0) return false;

    // Rule: Must be same instrument AND same product type
    const matchingPosition = positionData.find(position =>
      (String(position.token) === String(payload?.token) ||
        String(position.instrument_token) === String(payload?.token)) &&
      position.net_quantity !== 0 &&
      position.product === product 
    );

    if (!matchingPosition) return false;

    const netQuantity = Number(matchingPosition.net_quantity) || 0;
    const positionSide = netQuantity < 0 ? "SELL" : "BUY";

    // Rule: Order side must be OPPOSITE to position side
    const isOppositeDirection =
      (positionSide === "BUY" && orderSide === "SELL") ||
      (positionSide === "SELL" && orderSide === "BUY");

    if (!isOppositeDirection) return false;

    // Rule: Entered quantity must be <= open position quantity (No overshooting)
    return numericQty <= Math.abs(netQuantity);
  };

  const handleSubmit = async () => {
    // Check if opened as square-off and user hasn't changed the side or product
    const isDirectSquareOff = payload?.isSquareOff || false;
    // Check if this is a position-based square-off
    let isPositionBasedSquareOff = false;

    // Only check if not already a direct square-off
    if (!isDirectSquareOff) {
      const positionsArray = positionData || [];
      if (positionsArray && positionsArray.length > 0) {
        const matchingPosition = positionsArray.find(position =>
          (String(position.token) === String(payload?.token) ||
            String(position.instrument_token) === String(payload?.token)) &&
          position.net_quantity !== 0 &&
          position.product === product
        );

        if (matchingPosition) {
          const netQuantity = Number(matchingPosition.net_quantity) || 0;
          const positionSide = netQuantity < 0 ? "SELL" : "BUY";
          const numericQty = parseInt(quantity) || 0;

          // If this is a square-off order (opposite direction of position)
          if ((positionSide === "BUY" && orderSide === "SELL") ||
            (positionSide === "SELL" && orderSide === "BUY")) {

            // If entered quantity is less than or equal to position quantity, it's a valid square-off
            if (numericQty <= Math.abs(netQuantity)) {
              isPositionBasedSquareOff = true;
              console.log("Valid position-based square-off detected for order submission");
            }
          }
        }
      }
    }

    // Final square-off flag (either direct or position-based)
    const isSquareOff = isDirectSquareOff || isPositionBasedSquareOff;

    console.log("Submit button clicked:", {
      isDirectSquareOff,
      isPositionBasedSquareOff,
      isSquareOff,
      quantity,
      orderType,
      price,
      quantityError,
      minimumQtyRequired
    });

    // Only validate fields if NOT a square-off operation
    if (!isSquareOff && (!quantity || (orderType === "LIMIT" && !price))) {
      showNotification("ERROR", { message: "Please fill all required fields" });
      return;
    }

    if (!isSquareOff && orderType === "STOPLOSSMARKET" && !orderDetails.trigger_price) {
      showNotification("ERROR", { message: "Please fill trigger price field" });
      return;
    }

    setLoading(true);
    try {
      // Get exchange with multiple fallbacks
      let exchangeValue = null;

      // First try to get from payload.series and alternate_exchange
      if (payload?.series?.toLowerCase() === "indices") {
        exchangeValue = alternate_exchange;
      }
      // Then try payload.exchange
      else if (payload?.exchange) {
        exchangeValue = payload.exchange;
      }
      // Then try the exchange prop
      else if (exchange) {
        exchangeValue = exchange;
      }

      if (!exchangeValue) {
        console.error('Exchange value not found in any source:', {
          payload,
          exchange,
          series: payload?.series,
          alternate_exchange: alternate_exchange
        });
        throw new Error('Exchange value is missing. Please try again.');
      }

      const orderData = {
        instrument_token: payload?.token || payload?.instrument_token,
        order_side: orderSide,
        order_type:
          orderType === "STOPLOSS"
            ? "SL"
            : orderType === "STOPLOSSMARKET"
              ? "SLM"
              : orderType,
        price:
          orderType === "MARKET"
            ? 0
            : orderType === "STOPLOSSMARKET"
              ? 0
              : parseFloat(price),
        product: exchangeValue === "CDS" ? "NRML" :exchangeValue==="DCSX"?"CNC":product,
        quantity: parseInt(quantity),
        trigger_price:
          orderType === "MARKET"
            ? 0
            : orderType === "LIMIT"
              ? 0
              : orderType === "SL"
                ? price
                : 0,
        disclosed_quantity: 0,
        validity: validity,
        exchange: exchangeValue,
        execution_type: executionType || "REGULAR",
        user_order_id: Date.now(),
        is_square_off: isSquareOff, // Use combined flag
        // Only eligible for math check if explicitly opened as a square-off
        is_reducing_qty: computeIsReducingQty(isDirectSquareOff), 
      };

      console.log('Order data being sent:', orderData);

      if (payload?.source === "BASKET") {
        const basketPayload = createBasketOrderPayload({
          basketId: payload.basketDetails.basketId,
          basketName: payload.basketDetails.basketName,
          orderWindow: {
            ...orderData,
            orderSide: orderSide,
            token: payload.token || payload.instrument_token,
            trading_symbol: trading_symbol,
            instrument_name: payload.instrument_name || payload.series || "",
            // Scrip info fields for margin calculation
            raw_board_lot_quantity: payload.raw_board_lot_quantity,
            trading_unit_factor: payload.trading_unit_factor,
            multiplier: payload.multiplier,
            lot_size: payload.lotsize || payload.raw_board_lot_quantity,
            underlying_token: payload.underlying_token,
          }
        });
        const res = await dispatch(addBasketInstrumentAction(basketPayload));
        if (res.status === "success") {
          showNotification("SUCCESS", { message: "Added to basket successfully" });
        } else {
          showNotification("ERROR", { message: res.message || "Failed to add to basket" });
        }
        setLoading(false);
        dispatch(closeOrderWindow());
        return;
      }

      const response = await apiService.placeOrder(orderData);

      if (response.status === "success") {
        showNotification("NEW_ORDER", {
          order_side: orderSide,
          quantity: quantity,
          symbol: trading_symbol,
          price: orderType === "MARKET" ? "MARKET" : price,
        });
      } else {
        showNotification("ERROR", {
          message: response.message || "Order placement failed",
        });
      }
    } catch (err) {
      console.error("Order placement error:", err);
      showNotification("ERROR", {
        message: err.message || "Failed to place order. Please try again.",
      });
    } finally {
      setLoading(false);
      dispatch(closeOrderWindow());
    }
  };

  const handleModify = async () => {
    // Get direct square-off flag from payload
    const isDirectSquareOff = payload?.isSquareOff || false;

    // Check if this is a position-based square-off
    let isPositionBasedSquareOff = false;

    // Only check if not already a direct square-off
    if (!isDirectSquareOff) {
      const positionsArray = positionData || [];
      if (positionsArray && positionsArray.length > 0) {
        const matchingPosition = positionsArray.find(position =>
          (String(position.token) === String(payload?.token) ||
            String(position.instrument_token) === String(payload?.token)) &&
          position.net_quantity !== 0 &&
          position.product === product
        );

        if (matchingPosition) {
          const netQuantity = Number(matchingPosition.net_quantity) || 0;
          const positionSide = netQuantity < 0 ? "SELL" : "BUY";
          const numericQty = parseInt(quantity) || 0;

          // If this is a square-off order (opposite direction of position)
          if ((positionSide === "BUY" && orderSide === "SELL") ||
            (positionSide === "SELL" && orderSide === "BUY")) {

            // If entered quantity is less than or equal to position quantity, it's a valid square-off
            if (numericQty <= Math.abs(netQuantity)) {
              isPositionBasedSquareOff = true;
              console.log("Valid position-based square-off detected for order modification");
            }
          }
        }
      }
    }

    // Final square-off flag (either direct or position-based)
    const isSquareOff = isDirectSquareOff || isPositionBasedSquareOff;

    // Only validate fields if NOT a square-off operation
    if (!isSquareOff && (!quantity || (orderType === "LIMIT" && !price))) {
      showNotification("ERROR", { message: "Please fill all required fields" });
      return;
    }

    setLoading(true);
    try {
      const orderData = {
        instrument_token: payload?.token
          ? payload.token
          : payload.instrument_token,
        order_side: orderSide,
        order_type: orderType === "STOPLOSSMARKET" ? "SLM" : orderType,
        price: orderType === "MARKET" ? 0 : parseFloat(price),
        product: exchange === "CDS" ? "NRML" :exchange==="DCSX"?"CNC":product,
        quantity: parseInt(quantity),
        trigger_price: orderType === "MARKET" ? 0 : orderType === "LIMIT" ? 0 : orderType === "SL" ? price : 0,
        disclosed_quantity: 0,
        validity: "DAY",
        exchange: exchange,
        execution_type: execution || "REGULAR",
        user_order_id: Date.now(),
        oms_order_id: oms_order_id,
        exchange_order_id: exchange_order_id,
        is_square_off: isSquareOff, // Use combined flag
        is_reducing_qty: computeIsReducingQty(Boolean(payload?.is_reducing_qty)),
      };

      console.log('Modify order data being sent:', orderData);

      if (payload?.source === "MODIFY_BASKET") {
        const basketPayload = createBasketOrderPayload({
          basketId: payload.basketDetails.basketId,
          basketName: payload.basketDetails.basketName,
          orderWindow: {
            ...orderData,
            orderSide: orderSide,
            token: payload.token || payload.instrument_token,
            trading_symbol: trading_symbol,
            instrument_name: payload.instrument_name || payload.series || "",
            // Scrip info fields for margin calculation
            raw_board_lot_quantity: payload.raw_board_lot_quantity,
            trading_unit_factor: payload.trading_unit_factor,
            multiplier: payload.multiplier,
            lot_size: payload.lotsize || payload.raw_board_lot_quantity,
            underlying_token: payload.underlying_token,
          }
        });
        basketPayload.order_id = payload.basketDetails.id;

        const res = await dispatch(updateBasketInstrumentAction(basketPayload));
        if (res.status === "success") {
          showNotification("SUCCESS", { message: "Modified basket leg successfully" });
          setTimeout(() => {
            onClose();
          }, 1000);
        } else {
          showNotification("ERROR", { message: res.message || "Failed to modify basket leg" });
        }
        setLoading(false);
        dispatch(closeOrderWindow());
        return;
      }

      const response = await apiService.modifyOrder(orderData);

      if (response.status === "success") {
        // debugger
        showNotification("NEW_ORDER", {
          order_side: orderSide,
          quantity: quantity,
          symbol: trading_symbol,
          price: orderType === "MARKET" ? "MARKET" : price,
        });
        setTimeout(() => {
          onClose();
        }, 1000);
      }
      else{
        enqueueSnackbar(response.message, { variant: "error",anchorOrigin:{vertical:"top",horizontal:"right"} });
      }

      // Fetch positions after modifying a live order
      dispatch(fetchPositionsAction());
    } catch (err) {
      console.log("Order placement error:", err);
      enqueueSnackbar(err.message, { variant: "error" });
      console.error("Order placement error:", err);
    } finally {
      setLoading(false);
    }
  };

  const radioTypeOptions = [
    { value: "LIMIT", label: "Lim" },
    { value: "MARKET", label: "Mkt" },
    { value: "SL", label: "SL" },

  ];

  // Add this useEffect at the end of the hook to ensure square-off operations always have minimumQtyRequired set to 0
  useEffect(() => {
    // Force minimumQtyRequired to 0 for square-off operations
    if (payload?.isSquareOff) {
      // console.log("SQUARE OFF MODE DETECTED - Forcing minimum quantity to 0");
      // console.log("Previous minimumQtyRequired:", minimumQtyRequired);
      // console.log("Previous quantityError:", quantityError);

      setMinimumQtyRequired(0);
      setQuantityError(false);

      // Log again after state updates to confirm changes
      // setTimeout(() => {
      //   console.log("Updated minimumQtyRequired:", minimumQtyRequired);
      //   console.log("Updated quantityError:", quantityError);
      // }, 100);
    }
  }, [payload?.isSquareOff, minimumQtyRequired, quantityError]);

  // Add a useEffect that runs once on mount to detect square-off mode
  useEffect(() => {
    // Check for square-off mode when component mounts
    const isSquareOff = payload?.isSquareOff || false;
    if (isSquareOff) {
      // console.log("COMPONENT MOUNT: Square-off mode detected");
      // Force disable validation for square-off
      setMinimumQtyRequired(0);
      setQuantityError(false);
    }
  }, [payload?.isSquareOff]);

  return {
    // State
    orderType,
    hideMargin,
    is_modify,
    is_repeat,
    quantity,
    price,
    loading,
    currentLTP,
    lotsize,
    currentBestBid,
    currentBestAsk,
    product,
    validity,
    executionType,
    priceError,
    triggerError,
    quantityError,
    orderSide,
    orderDetails,
    isDisabled: payload?.isSquareOff ? (priceError || triggerError) : (priceError || triggerError || quantityError), // Override isDisabled for square-off
    userData,
    strike_price,
    minimumQtyRequired,
    minimumOrderValue,
    PRIME_SETTINGS,
    isSquareOffOrder,
    existingPositionQty,
    marginConfig,
    marginConfigLoading,
    marginConfigError,
    // Setters
    setOrderType,
    setProduct,
    setPrice,
    setValidity,
    setExecutionType,

    // Handlers
    handleTypeChange,
    handleChange,
    handlePriceChange,
    handleTriggerKeyDown,
    handleTriggerChange,
    handleQuantityChange,
    handleQuantityKeyDown,
    handlePriceKeyDown,
    handleSubmit,
    handleModify,

    // Utils
    getProductOptions,
    radioTypeOptions,
    hasMatchingPosition,
  };
};
